module.exports = __webpack_public_path__ + "img/icon-cykel.66718221.png";